import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SideBar from './SideBar';
import Inbox from './Inbox';
import ChatInterface from './ChatInterface';

const Chat = () => {
  return (
    <div className="p-4 flex h-screen sm:ml-64 bg-[#F4F5F6]">
      <SideBar />
      <div className="flex-1 flex flex-col">
        <Routes>
          <Route path="" element={<Inbox />} />
          <Route path="/compose" element={<ChatInterface />} />
        </Routes>
      </div>
    </div>
  );
};

export default Chat;
